
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    text: String,
  },
})
export default class CourseEditorButton extends Vue {}
